const dynamicPhoto = {
  priceMonth: '$9.99',
  priceYear: '$4.99',
  Monthly: 'Monthly',
  Weekly: 'Weekly',
  Yearly: 'Yearly',
  NoImageSizeLimits: 'No Image Size Limits',
  UnlimitedImageUploads: 'Unlimited Image Uploads',
  DownloadWithoutWatermark: 'Download HD Image with No Watermark',
  DownloadGif: 'Download Video as GIF',
};

export default dynamicPhoto;
